import React from 'react'
import ReactSelect from './ReactSelect'

export default function CurrencySelect({ error, isClearable, name, handleBlur, value, disabled, onChange, label, noLabelPadding }) {

  const currencyOptions = [
    { label: '€ Euro', value: 'EUR', symbol: '€' },
    { label: 'CHF Swiss Franc', value: 'CHF', symbol: 'CHF' },
    { label: '$ US Dollar', value: 'USD', symbol: '$' },

    { label: '¥ Japanese Yen', value: 'JPY', symbol: '¥' },
    { label: '£ British Pound', value: 'GBP', symbol: '£' },
    { label: '¥ Chinese Renminbi (Yuan)', value: 'CNY', symbol: '¥' },
    { label: 'C$ Canadian Dollar', value: 'CAD', symbol: 'C$' },
    { label: 'A$ Australian Dollar', value: 'AUD', symbol: 'A$' },
    { label: 'NZ$ New Zealand Dollar', value: 'NZD', symbol: 'NZ$' },
    { label: 'HK$ Hong Kong Dollar', value: 'HKD', symbol: 'HK$' },
    { label: 'S$ Singapore Dollar', value: 'SGD', symbol: 'S$' },
    { label: '₩ South Korean Won', value: 'KRW', symbol: '₩' },
    { label: '₹ Indian Rupee', value: 'INR', symbol: '₹' },
    { label: 'R$ Brazilian Real', value: 'BRL', symbol: 'R$' },
    { label: '$ Mexican Peso', value: 'MXN', symbol: '$' },
    { label: '₽ Russian Ruble', value: 'RUB', symbol: '₽' },
    { label: '₺ Turkish Lira', value: 'TRY', symbol: '₺' },
    { label: 'R South African Rand', value: 'ZAR', symbol: 'R' },
    { label: '﷼ Saudi Riyal', value: 'SAR', symbol: '﷼' },
    { label: 'د.إ UAE Dirham', value: 'AED', symbol: 'د.إ' },
    { label: 'ر.ق Qatari Riyal', value: 'QAR', symbol: 'ر.ق' },
    { label: 'د.ك Kuwaiti Dinar', value: 'KWD', symbol: 'د.ك' },
    { label: 'د.ب Bahraini Dinar', value: 'BHD', symbol: 'د.ب' },
    { label: 'ر.ع. Omani Rial', value: 'OMR', symbol: 'ر.ع.' },
    { label: '₪ Israeli New Shekel', value: 'ILS', symbol: '₪' },
    { label: 'zł Polish Złoty', value: 'PLN', symbol: 'zł' },
    { label: 'kr Swedish Krona', value: 'SEK', symbol: 'kr' },
    { label: 'kr Norwegian Krone', value: 'NOK', symbol: 'kr' },
    { label: 'kr Danish Krone', value: 'DKK', symbol: 'kr' },
    { label: 'Kč Czech Koruna', value: 'CZK', symbol: 'Kč' },
    { label: 'Ft Hungarian Forint', value: 'HUF', symbol: 'Ft' },
    { label: 'lei Romanian Leu', value: 'RON', symbol: 'lei' },
    { label: 'Rp Indonesian Rupiah', value: 'IDR', symbol: 'Rp' },
    { label: 'RM Malaysian Ringgit', value: 'MYR', symbol: 'RM' },
    { label: '฿ Thai Baht', value: 'THB', symbol: '฿' },
    { label: '₱ Philippine Peso', value: 'PHP', symbol: '₱' },
    { label: '₫ Vietnamese Đồng', value: 'VND', symbol: '₫' },
    { label: 'E£ Egyptian Pound', value: 'EGP', symbol: 'E£' },
    { label: '₦ Nigerian Naira', value: 'NGN', symbol: '₦' },
    { label: 'KSh Kenyan Shilling', value: 'KES', symbol: 'KSh' },
    { label: '$ Argentine Peso', value: 'ARS', symbol: '$' },
    { label: '$ Chilean Peso', value: 'CLP', symbol: '$' },
    { label: '$ Colombian Peso', value: 'COP', symbol: '$' },
    { label: '₡ Costa Rican Colón', value: 'CRC', symbol: '₡' }
  ]

  return (
    <ReactSelect
      error={error}
      isClearable={isClearable}
      name={name}
      onChange={onChange}
      onBlur={handleBlur}
      value={value}
      options={currencyOptions}
      disabled={disabled}
      label={label}
      noLabelPadding={noLabelPadding}
    />
  )
}
